import { render, staticRenderFns } from "./SystemDetailsPage.vue?vue&type=template&id=efc325ee&scoped=true"
import script from "./SystemDetailsPage.vue?vue&type=script&lang=js"
export * from "./SystemDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc325ee",
  null
  
)

export default component.exports